import React from 'react'
import PageContainer from 'layout/default-sidebar-layout/PageContainer'
import { autobind } from 'core-decorators'
import QAApi from 'api/QAApi'
import QAForm from '../form'
import createManagerEdit from 'hoc/manager-edit'
import PropTypes from 'prop-types'
import Breadcrumb from '../breadcrumb'

@createManagerEdit({
  apiUpdate: QAApi.updateQA,
  apiGetByKey: QAApi.getQAByID
})
@autobind
export default class QAEdit extends React.PureComponent {
  static propTypes = {
    onUpdateItem: PropTypes.func,
    getItem: PropTypes.func,
    isLoaded: PropTypes.bool
  }

  async handleSubmit(data) {
    this.props.onUpdateItem(data)
  }

  //Su kien truoc khi component duoc tao ra
  async componentWillMount() {
    this.props.getItem()
  }
  render() {
    return (
      <PageContainer>
        <Breadcrumb items={['list', 'edit']} />
        {this.props.isLoaded &&
          this.props.data && (
            <QAForm
              initialValues={this.props.data}
              onSubmit={this.handleSubmit}
              isEdit
            />
          )}
      </PageContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/qa/edit/index.js